<template>
  <vue-final-modal v-model="state" classes="modal-container-player" content-class="modal-content-player">
    <div class="modal__content-player">
      <video ref="videoPlayer"
        class="video-js vjs-big-play-centered vjs-16-9"
        :playsinline="true"
         @contextmenu.prevent
        controlsList="nodownload"></video>
    </div>

  </vue-final-modal>
</template>


<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import '@videojs/themes/dist/sea/index.css';

export default {

  name: "VideoPopup",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    data: {
      required: true,
    },
  },

  data() {
    return {
      state: this.dialog,
      videoLoaded: false,

      // videojs options
      playerOptions: {
        fluid: true,
        width: '1260',
        height: '396',
        autoplay: true,
        controls: true,
        muted: false,
        language: 'en',
        sources: [{
            type: "video/mp4",
            src:"",
        }],
        tracks: [],
        poster: "",
        playbackRates: [0.5, 1, 1.5, 2],
        textTrackSettings: false,
        html5: {nativeTextTracks: false}
      },
    };
  },

  mounted() {

    this.playerOptions.sources[0].src = this.data.url;
    this.playerOptions.poster = this.data.thumbnail;

    this.player = videojs(this.$refs.videoPlayer, this.playerOptions, () => {
    // load on error
    let retries = 4;
    this.player.on('error', () => {
      if (retries--){
          setTimeout(() => {
              this.player.pause();
              this.player.load();
          }, 500);
      }

      if (retries < 0) this.player.pause()
    })

    })

    this.videoLoaded = true

  }

}
</script>

<style scoped>
  .video-js.video-js .vjs-big-play-button {
  background-color: #00a1c100;
  opacity: .7;
  width: 150px;
  height: 150px;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  border-radius: 100%;
  border-style: solid;
  border-width: 2px;
  border-color: #ffffff;
  padding: 0px;
}

.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
   content: "";
   background-image: url('~@/assets/img/play.png');
   background-repeat: no-repeat;
   background-size: 60px;
   background-position: 55% calc(50% - 0px);
   border: none !important;
   box-shadow: none !important;

  }

  @media only screen and (max-width: 600px) {
    .video-js.video-js .vjs-big-play-button {
      width: 70px;
      height: 70px;
    }

    .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
      background-size: 20px;
    }

  }

  .vjs-menu li {
    font-size: 10px !important;
    text-transform: capitalize !important;
  }
</style>

<!-- modal styles -->

<style scoped>
:deep(.modal-container-player) {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.modal-content-player) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  margin: 0 1rem;
  padding: 0px;
  border-radius: 0.25rem;
  width: 50%;
}
.modal__content-player {
  flex-grow: 1;
  overflow-y:visible;
}
</style>